import type { ReactNode } from "react";
import { AlertTriangle, CheckCircle2, X } from "lucide-react";

export function PageHeader({ eyebrow, title, text, action }: { eyebrow?: string; title: string; text?: string; action?: ReactNode }) {
  return <div className="page-header"><div>{eyebrow && <span className="eyebrow">{eyebrow}</span>}<h1>{title}</h1>{text && <p>{text}</p>}</div>{action}</div>;
}

export function EmptyState({ icon, title, text }: { icon: ReactNode; title: string; text: string }) {
  return <div className="empty-state"><span>{icon}</span><h3>{title}</h3><p>{text}</p></div>;
}

export function Loading() { return <div className="loading"><span className="spinner spinner--dark" />Загрузка данных…</div>; }

export function Alert({ type = "error", children }: { type?: "error" | "success"; children: ReactNode }) {
  return <div className={`alert alert--${type}`}>{type === "error" ? <AlertTriangle size={18} /> : <CheckCircle2 size={18} />}{children}</div>;
}

export function Modal({ title, children, onClose, wide = false }: { title: string; children: ReactNode; onClose: () => void; wide?: boolean }) {
  return <div className="modal-layer" role="dialog" aria-modal="true" aria-label={title}>
    <button className="modal-backdrop" onClick={onClose} aria-label="Закрыть" />
    <section className={`modal ${wide ? "modal--wide" : ""}`}><header><h2>{title}</h2><button className="icon-button" onClick={onClose}><X /></button></header>{children}</section>
  </div>;
}

export function formatNumber(value: number) { return new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 4 }).format(value); }
export function formatDate(value: string) { return new Intl.DateTimeFormat("ru-RU", { dateStyle: "medium", timeStyle: "short" }).format(new Date(value)); }

